import React, { useState, useEffect } from 'react';
import CreatePool from './CreatePool';
import { getPools, getPoolModels, getModelById, getDownloadLink } from '../../utils/api';
import RenderModels from '../RenderModels';
import { fetchPoolModels } from '../../utils/Pool/fetchPoolModels';
import CreateCasting from './Casting/CreateCasting';

const PoolView = ({ selectedPool = null, setSelectedPool = () => { }, pools }) => {
  const [editingPool, setEditingPool] = useState(false); // Track pool being edited
  const [isCreateCasting, setisCreateCasting] = useState(false); // Track Casting being created from this pool
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modelPage, setModelPage] = useState(1); // Page for models
  const [totalModelPages, setTotalModelPages] = useState(1); // Total model pages

  const MODELS_PER_PAGE = 10; // Number of models to fetch per page

  useEffect(() => {
    if (selectedPool) {
      fetchPoolModels(selectedPool.pool_id, setModels, setTotalModelPages, setLoading, modelPage, MODELS_PER_PAGE);
    }
  }, [selectedPool, modelPage]);

  const handleEditPool = async () => {
    setEditingPool(true);
  };

  const handleBackToPools = () => {
    setSelectedPool(null); // Deselect the pool
    setModels([]); // Clear models
  };

  const handleModelPageChange = (direction) => {
    const newPage = modelPage + direction;
    if (newPage > 0 && newPage <= totalModelPages) {
      setModelPage(newPage);
    }
  };

  const handleCreateCasting = () => {
    setisCreateCasting(true);
  };

  return (
    isCreateCasting ? (
      <CreateCasting
        pools={pools}
        onBack={() => { setisCreateCasting(false) }} // Reset editingPool on back
        pool={selectedPool}
      />
    ) : editingPool ? (
      <CreatePool
        pools={pools}
        onBack={() => { setEditingPool(false) }} // Reset editingPool on back
        pool={selectedPool}
        poolId={selectedPool.pool_id}
      />
    ) : (
      <div className="models-all">
        <div style={{ textAlign: 'left' }}>
          <label>Note:</label><br />
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
          <br />
          <button className="button" onClick={handleCreateCasting}>
            Create Casting
          </button>
          <button className="button" onClick={handleBackToPools}>
            Back to Pools
          </button>
          <button className="button" onClick={handleEditPool}>
            Edit Pool
          </button>
        </div>
        <h1 className="modal-title">Models in {selectedPool.pool_id}</h1>
        {loading ? (
          <p>Loading models...</p>
        ) : (
          <>
            <RenderModels models={models} />
            <hr className='fitting-break' />
          </>
        )}


        <div className="pagination">
          <button
            className="button"
            onClick={() => handleModelPageChange(-1)}
            disabled={modelPage === 1}
          >
            Previous
          </button>
          <span>
            Page {modelPage} of {totalModelPages}
          </span>
          <button
            className="button"
            onClick={() => handleModelPageChange(1)}
            disabled={modelPage === totalModelPages}
          >
            Next
          </button>
        </div>
      </div>
    ));
};

export default PoolView;
